import { call, put, takeEvery } from 'redux-saga/effects';
import { CreateNewDealerCustomer, newDealerActionCreators, NewDealerActionKeys } from '../';
import { IEntityWithMessages } from '../../../services/HttpService';
import { addressActionCreators } from '../../address';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { businessEntityActionCreators } from '../../businessEntity';
import { prospectActionCreators } from '../../prospects';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';
import { INewDealerRequestApiResponse } from '../newDealerInterfaces';

function* createNewDealerCustomerSaga(action: CreateNewDealerCustomer) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestApiResponse>> = yield call(
    api.createNewDealerCustomer,
    action.payload.newDealerRequestId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      const { prospect, request } = response.value.value;

      yield put(newDealerActionCreators.setRequest(request));
      yield put(prospectActionCreators.setProspects([prospect]));
      yield put(addressActionCreators.setAddresses(prospect.addresses));
      yield put(
        businessEntityActionCreators.addAddresses([
          {
            addressIds: prospect.addresses.map(x => x.addressId),
            businessEntityId: prospect.businessEntityId
          }
        ])
      );

      yield put(
        businessEntityActionCreators.addNames([{ businessEntityId: prospect.businessEntityId, name: prospect.name }])
      );
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchCreateNewDealerCustomer() {
  yield takeEvery(NewDealerActionKeys.CREATE_NEW_DEALER_CUSTOMER, createNewDealerCustomerSaga);
}
